export const TOGGLE_MODAL_EMAIL_SENT = 'TOGGLE_MODAL_EMAIL_SENT';

export function toggleModalEmailSent() {
  return {
    type: TOGGLE_MODAL_EMAIL_SENT,
  };
}
